function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var PageTypePrefixes = (_obj = {}, _define_property(_obj, "en", {
    article: "news",
    event: "event",
    researchGroup: "research-group",
    researchPlatform: "research-platform",
    researchProject: "research-project",
    search: "search"
}), _define_property(_obj, "fr", {
    article: "actualite",
    event: "evenement",
    researchGroup: "groupe-de-recherche",
    researchPlatform: "plateforme-technologique",
    researchProject: "projet-de-recherche",
    search: "recherche"
}), _define_property(_obj, "nl", {
    article: "nieuws",
    event: "evenement",
    researchGroup: "onderzoeksgroep",
    researchPlatform: "onderzoeksplatform",
    researchProject: "onderzoeksproject",
    search: "zoeken"
}), _obj);

//# sourceMappingURL=PageTypePrefixes.js.map